/**
 * God-rays / aurora — strong diagonal volumetric light beams from top-left.
 * Combined with soft coloured ribbons for atmosphere.
 */

interface Ray {
  angle: number       // radians
  offset: number      // starting x position
  width: number       // beam width
  speed: number       // drift speed multiplier
  alpha: number
  color: string
}

export class Aurora {
  private w = 0
  private h = 0
  private t = 0
  private rays: Ray[] = []

  resize(w: number, h: number): void {
    this.w = w
    this.h = h

    // 6 diagonal god rays with varied widths + alpha
    this.rays = []
    for (let i = 0; i < 6; i++) {
      this.rays.push({
        angle: -0.38 + Math.random() * 0.12,
        offset: -w * 0.2 + Math.random() * (w * 1.4),
        width: w * (0.14 + Math.random() * 0.12),
        speed: 0.002 + Math.random() * 0.0025,
        alpha: 0.1 + Math.random() * 0.08,
        color: Math.random() > 0.6 ? 'rgba(255, 245, 220, ' : 'rgba(200, 232, 252, ',
      })
    }
  }

  tick(dt: number): void {
    this.t += dt
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.save()
    ctx.globalCompositeOperation = 'lighter'

    for (const r of this.rays) {
      const x = ((r.offset + this.t * r.speed * 30) % (this.w + r.width * 2)) - r.width
      ctx.save()
      ctx.translate(x, -this.h * 0.25)
      ctx.rotate(r.angle)

      const g = ctx.createLinearGradient(0, 0, r.width, 0)
      g.addColorStop(0, `${r.color}0)`)
      g.addColorStop(0.5, `${r.color}${r.alpha})`)
      g.addColorStop(1, `${r.color}0)`)
      ctx.fillStyle = g
      ctx.fillRect(0, 0, r.width, this.h * 1.8)

      ctx.restore()
    }

    ctx.restore()
  }
}
